import React, { useState, useEffect } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";

const CallChatStatus = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );

 
  const fetchData = async (from, to) => {
    try {
      setLoading(true);

      const payload = { DeletedDateFrom: from, DeletedDateTo: to, Type: "" };
      const res = await AddUpdate("WaitingList/GetData_StatusCount", payload);

      if (res) {
        const parsed = JSON.parse(res?.data?.data || "{}");
        setData(parsed?.Table || []);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(startDate, endDate);
  }, []);

  const handleSearch = () => {
    fetchData(startDate, endDate);
  };

  return (
    <>
      
      <div className="form-group main_card">
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>
          Call/Chat Status
        </h2>

        <div className="row mt-3">
          <div className="col-3">
            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-3">
            <label>End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="col-auto">
            <button
              className="btn btn-primary mt-4"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
        </div>
      </div>

    
      <div className="col-12 mt-3 main_card">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead style={{ background: "#0b1e3c", color: "#fff" }}>
                <tr>
                  <th>Astrologer Name</th>
                  <th>Type</th>
                  <th>Completed</th>
                  <th>Waiting</th>
                  <th>Other</th>
                </tr>
              </thead>

              <tbody>
                {data.length === 0 && (
                  <tr>
                    <td colSpan="5">No data available</td>
                  </tr>
                )}

                {data.map((item, index) => {
                  let parsed = [];

                  try {
                    parsed = JSON.parse(item.Data || "[]");
                  } catch {
                    parsed = [];
                  }

                  
                  parsed.sort((a, b) =>
                    a.Type === "call" ? -1 : 1
                  );

                  return parsed.map((p, i) => (
                    <tr key={`${index}-${i}`}>
                      {/* ✅ ROWSPAN CELL */}
                      {i === 0 && (
                        <td
                          rowSpan={parsed.length}
                          style={{
                            verticalAlign: "middle",
                            fontWeight: "600",
                            textAlign: "left",
                            paddingLeft: "10px",
                          }}
                        >
                          {item.DisplayName}
                        </td>
                      )}

                      <td style={{ textTransform: "capitalize" }}>
                        {p.Type}
                      </td>
                      <td>{p.CompletedCount}</td>
                      <td>{p.WaitingCount}</td>
                      <td>{p.OtherCount}</td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default CallChatStatus;